import type { ImageLoaderProps } from 'next/image';

const CARD_RATIO = 3 / 2; // 3:2

export default function keyCdnCardLoader({ src, width, quality }: ImageLoaderProps) {
  const MAX_W = 480;
  const w = Math.min(width ?? MAX_W, MAX_W);
  const h = Math.round(w / CARD_RATIO);
  const q = Math.min(quality ?? 70, 80);

  // 1. Плейсхолдеры / data-URL / blob — не трогаем
  if (!src || src.startsWith('data:') || src.startsWith('blob:')) {
    return src;
  }

  // 2. Если это локная картинка из /public (например /broken-image.svg),
  //    можно вернуть её без трансформаций
  if (src.startsWith('/')) {
    return src;
  }

  // 3. Для CDN-url аккуратно добавляем/меняем параметры
  const [base, queryString] = src.split('?', 2);
  const params = new URLSearchParams(queryString ?? '');

  params.set('width', String(w));
  params.set('height', String(h));
  params.set('crop', 'smart');
  params.set('quality', String(q));

  return `${base}?${params.toString()}`;
}
